import {
  Box,
  IconButton,
  Select,
  TextField,
  ToggleButton,
  Typography,
  TypographyProps,
} from "@mui/material";
import { BoxProps, styled } from "@mui/system";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { CustomButton } from "../functional/customButton/CustomButton";

export const RoundedButton = styled(CustomButton)(() => ({
  borderRadius: "20px",
}));

export const ActionToggleButton = styled(ToggleButton)(({ theme }) => ({
  borderRadius: "20px",
  padding: "5px 15px",
  color: theme.palette.primary.main,
  borderColor: `${theme.palette.primary.main}80`, // ~50% opacity
  fontFamily: "Quicksand, sans-serif",
  fontWeight: "700",
  textTransform: "none",
  "&:hover": {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  "&.Mui-selected": {
    border: "none",
    backgroundColor: theme.palette.primary.light,
    color: "#fff",
  },
  "&.Mui-selected:hover": {
    backgroundColor: theme.palette.hover.primaryLight,
  },
}));

export const Heading1 = styled(Typography)(() => ({
  fontFamily: "Quicksand",
  fontSize: "32px",
  fontWeight: 600,
  padding: "20px 10px",
}));

export const Heading3 = styled(Typography)(() => ({
  fontFamily: "Quicksand",
  fontSize: "24px",
  fontWeight: 600,
}));

type FormSectionContainerProps = {
  noBorder?: boolean;
  disablePaddingBottom?: boolean;
};
export const FormSectionContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "noBorder" && prop !== "disablePaddingBottom",
})<FormSectionContainerProps>(({ noBorder, disablePaddingBottom }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  borderBottom: noBorder ? "unset" : "1px solid rgba(74, 29, 156, 0.12)",
  paddingBottom: disablePaddingBottom ? "0px" : "32px",
  position: "relative",
  marginBottom: "16px",
}));

export const StyledDialogContentWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  position: "relative",
}));

export const FormSectionHeader = styled(Typography)(() => ({
  textTransform: "uppercase",
  fontWeight: "700",
  lineHeight: 2.2,
}));

export const TextFieldLight = styled(TextField)(() => ({
  backgroundColor: "rgba(249, 249, 250, 0.6)",
}));

export const SelectLight = styled(Select)(() => ({
  backgroundColor: "rgba(249, 249, 250, 0.6)",
}));

export const SelectLightEllipses = styled(Select)(() => ({
  backgroundColor: "rgba(249, 249, 250, 0.6)",
  "& .MuiSelect-select": {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
}));

export const DesktopDatePickerLight = styled(DesktopDatePicker)(() => ({
  backgroundColor: "#F9F9FA",
}));

export const ActionsIconButton = styled(IconButton)(() => ({
  maxWidth: "34px",
  maxHeight: "34px",
  marginLeft: "4px",
  marginTop: "4px",
}));

export const FlexVerticalAligned = styled(({ ...props }: BoxProps) => (
  <Box {...props} />
))(() => ({
  display: "flex",
  alignItems: "center",
}));

export const UnderlineLink = styled(({ ...props }: TypographyProps) => (
  <Typography {...props} />
))(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: "underline",
  cursor: "pointer",
  fontSize: "14px",
}));
